var map = {
	"./Bootstrap.png": 60,
	"./CSS.png": 61,
	"./Git.png": 62,
	"./HTML.png": 63,
	"./IntelliJ.png": 64,
	"./Java.png": 65,
	"./Node.png": 66,
	"./Postman.png": 67,
	"./Python.png": 68,
	"./Redux.png": 69,
	"./Sass.png": 70,
	"./Slack.png": 71,
	"./Spring.png": 72,
	"./VSCode.png": 73,
	"./firebase.png": 74,
	"./jquery.png": 75,
	"./mongo.png": 76,
	"./typescript.png": 77,
	"./vue.png": 78
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;